
























import Component, { mixins } from "vue-class-component";
import { InputUserUpdate, User } from "@scrile/api-provider/dist/api/UserProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import PageTitle from "@/components/PageTitle";

@Component({ name: "SignUpEmailConfirm", components: { BaseInput, BaseButton, PageTitle } })
export default class SignUpEmailConfirm extends mixins(WithAuthUser) {
  public currentEmail: string = "";

  public loading: boolean = false;

  public isValid: boolean = false;

  get email(): string {
    if (this.currentEmail !== "") return this.currentEmail;
    return (this.authUser && this.authUser.email) || "";
  }

  set email(value) {
    this.currentEmail = value;
  }

  get user(): User {
    return this.authUser as User;
  }

  public async submit() {
    if (!this.isValid) return;
    this.loading = true;
    let data: InputUserUpdate = {
      id: this.user.id,
      email: this.email,
    };
    try {
      const user = await providers.UserProvider.update({ data });
      this.authUserSetSocialLoginStatus(false);
      this.authUserUpdate(user);
      this.$emit("confirm");
    } finally {
      this.loading = false;
    }
  }
}
